export enum ActionTypes {
    create = "create",
    edit = "edit",
    move = "move",
    block = "block",
    pick = "pick",
    undoPick = "undoPick",
    delete = "delete",
    returnPackingBoxes = "returnPackingBoxes"
}